import { ActionBar, FAIconName } from '@equip.health/ui';

type Props = {
  count: number;
  id: string;
};

export const HiddenCoOccurringProblemsActionBar = ({ count, id }: Props) => (
  <ActionBar
    barIcon={FAIconName.infoCircleRegular}
    id={id}
    text={
      <>
        <span style={{ fontWeight: 500 }}>
          {count === 1
            ? '1 co-occurring problem'
            : `${count} co-occurring problems`}
        </span>
        {count === 1
          ? ' is not displayed here. Once it has interventions assigned to your role, it’ll appear here for you to review.'
          : ' are not displayed here. Once they have interventions assigned to your role, they’ll appear here for you to review.'}
      </>
    }
    variant="info"
  />
);
